module.exports = __webpack_public_path__ + "assets/d5a6140d581e5c4eb200259ce372f40b.js";